module.exports = __webpack_public_path__ + "img/Monopoly.1ce9ca2b.png";